<script lang="ts">
	import ScWalletSidebar from '$lib/home/scwallet/SCWalletSidebar.svelte';
	import { orders, positions } from '$lib/home/store';
	import type { MarketIdentifiers } from '$lib/types/market';
	import MoreDropDown from '$lib/util/MoreDropDown/MoreDropDown.svelte';
	import MoreDropDownItem from '$lib/util/MoreDropDown/MoreDropDownItem.svelte';
	import { chain, walletConnected, walletLoaded } from '$lib/wallet/store';
	import Wallet from '$lib/wallet/Wallet.svelte';
	import HeaderItem from './HeaderItem.svelte';
	import MobileSideNav from './MobileSideNav.svelte';
	import SwitchToOptimism from './SwitchToOptimism.svelte';
	import { isSupportedNetwork } from '$lib/util/util';
	import ChainBanner from '$lib/downtime/ChainBanner.svelte';
	import ApiModified from './ApiModified.svelte';
	import { longOrShort, longOrShortUpdatedSinceLoad } from '$lib/home/userInteract/store';
	import { currentCompetitionConfig } from '$lib/leaderboard/store';
	import BigNumber from 'bignumber.js';
	import AnimatedBorder from '$lib/tradingSeason/shared/AnimatedBorder.svelte';

	let perpUrl: MarketIdentifiers = 'sETHPERP';
	$: if ($positions && $positions.data && $positions.data.length > 0) {
		perpUrl = $positions.data[0].marketIdentifier;
		if (!$longOrShortUpdatedSinceLoad) {
			longOrShort.set(new BigNumber($positions.data[0].size).isGreaterThan(0) ? 'Long' : 'Short');
			longOrShortUpdatedSinceLoad.set(true);
		}
	} else if ($orders && $orders.data && $orders.data.length > 0) {
		perpUrl = $orders.data[0].marketIdentifier;
	}
</script>

<header
	class="lg:block backdrop-blur-3xl sticky top-0 sm:bg-fx-black sm:bg-fx-gradient-none bg-fx-gradient-8 border-b border-fx-grey-600 sm:border-none z-50"
>
	<ChainBanner />
	<div class="py-0.5">
		<div class="mx-4 sm:mx-10 my-4">
			<div class="flex sm:items-start items-center">
				<a class="flex gap-2 pt-1 items-center" href="/" data-sveltekit-reload>
					<img
						class="rounded-lg sm:h-8 sm:w-8 h-6 w-6 bg-fx-gradient-8 p-0.5"
						src="/Logo.webp"
						loading="lazy"
						alt=""
					/>
					<div class="block font-semibold text-xl sm:text-2xl text-fx-gradient-5">Polynomial</div>
				</a>
				<div class="border-l h-10 border-l-fx-grey-500 w-px mx-6 sm:block hidden" />
				<div
					class=" border-fx-grey-500 hidden lg:flex justify-center gap-2 text-sm font-medium text-fx-grey-400"
				>
					<HeaderItem name="Overview" url="/" params="" />
					<HeaderItem name="Perps" url="/perps" params="market={perpUrl}" />
					<HeaderItem name="Markets" url="/markets" params="" />
					<HeaderItem name="Strategies" url="/strategies" params="" beta={true} />
					<!-- <HeaderItem name="Mystery Orbs" url="/mystery-orbs" params="" /> -->

					<MoreDropDown>
						<MoreDropDownItem
							imgSrc="/Logo.webp"
							heading="Wrapped 2023"
							description="Checkout your journey with Polynomial in 2023"
							url="http://wrapped23.polynomial.fi/"
						/>
						<MoreDropDownItem
							imgSrc="/header/earn.png"
							heading="Mystery Orbs"
							description="Find out what's inside the mystery orbs"
							url="/mystery-orbs"
						/>
						<MoreDropDownItem
							imgSrc="edit.svg"
							heading="Docs"
							description="Read up on how to use Trade"
							url="https://docs.trade.polynomial.fi"
						/>
						<MoreDropDownItem
							imgSrc="header/dune.png"
							heading="Analytics"
							description="View analytics of trade"
							url="https://dune.com/polynomialfi/polynomial-trade"
						/>
						<MoreDropDownItem
							imgSrc="header/token-terminal.jpeg"
							heading="Token Terminal"
							description="View polynomial trade analytics"
							url="https://tokenterminal.com/terminal/projects/polynomial-protocol"
						/>
						<!-- <MoreDropDownItem
							imgSrc="header/earn.png"
							heading="Trading Season"
							description="Polynomial's trading competition"
							url="/trading-season"
						/> -->
					</MoreDropDown>
				</div>

				<div class="flex flex-row-reverse gap-4 ml-auto items-center">
					<div class="my-auto sm:hidden">
						<MobileSideNav />
					</div>
					<div class="my-auto hidden sm:block">
						<ApiModified />
					</div>
					<div class="my-auto hidden sm:block">
						<Wallet />
					</div>
					{#if $walletLoaded && $walletConnected && !isSupportedNetwork($chain?.id)}
						<SwitchToOptimism />
					{/if}
					<div class="hidden sm:block">
						<ScWalletSidebar />
					</div>
				</div>
			</div>
		</div>
	</div>
</header>
